import type { AdminUserList, AdminUsersQuery } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const listAdminUsers = async (query: AdminUsersQuery): Promise<AdminUserList> =>
	unwrap(await request(() => httpClient.admin.users.get({ query })));
